import { createContext } from "react";
export const SoundContext = createContext(false);